var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMyProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DCF59736-BB51-4795-B624-8952049F8DC7@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google-TV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Operatory-Room-NAV",
    transform: "translate(-90.000000, -812.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Operatory-room-menu"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.26,
    fill: "#000000",
    x: 0,
    y: 0,
    width: 430,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90.000000, 210.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Specializations/White-Copy-4",
    transform: "translate(0.000000, 602.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.772374,23 C29.2903959,23 33.1356757,24.92 34.608336,27.96 C35.857866,30.6072727 35.9882883,32.3906336 35.9991249,32.870273 L35.9991819,33 L0.00081814463,33 L0.00081814463,33 L0.000875059831,32.870273 C0.0117117141,32.3906336 0.142134035,30.6072727 1.39166402,27.96 C2.94613881,24.92 6.70960411,23 10.227626,23 L10.227626,23 Z M18,2 C22.9705627,2 27,6.02943725 27,11 C27,15.9705627 22.9705627,20 18,20 C13.0294373,20 9,15.9705627 9,11 C9,6.02943725 13.0294373,2 18,2 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyProfile);
export default __webpack_public_path__ + "static/media/ic_my_profile.715a88f1.svg";
export { ForwardRef as ReactComponent };